import L from 'leaflet';

/**
 * Leaflet #3575 / #6101: overlap tile di 1px per evitare fessure bianche
 * tra i quadrati (Chrome/Edge, soprattutto con zoom frazionario).
 */
let patchApplied = false;

export function applyLeafletTileSeamPatch() {
    if (patchApplied || !L?.GridLayer?.prototype?._initTile) {
        return;
    }

    patchApplied = true;

    const originalInitTile = L.GridLayer.prototype._initTile;

    L.GridLayer.include({
        _initTile(tile) {
            originalInitTile.call(this, tile);
            const tileSize = this.getTileSize();
            tile.style.width = `${tileSize.x + 1}px`;
            tile.style.height = `${tileSize.y + 1}px`;
        },
    });
}

applyLeafletTileSeamPatch();
